import { Platform } from 'react-native';

// URL del backend de produccion (puerto 3002). Puede sobreescribirse en build
// con EXPO_PUBLIC_API_URL para apuntar a otro entorno sin tocar codigo.
const DEFAULT_API_URL = 'http://207.244.237.123:3002/api';

// En web usamos URL relativa para que el reverse-proxy del mismo dominio sirva
// /api y se evite Mixed Content cuando la app web va por HTTPS.
const WEB_API_URL = '/api';

export const API_URL =
  Platform.OS === 'web'
    ? WEB_API_URL
    : process.env.EXPO_PUBLIC_API_URL || DEFAULT_API_URL;
